// AI工作台基础翻译

export const workbench = {
    title: 'AI工作台',
    subtitle: '专业的AI驱动图像生成和编辑工作空间',
    workbenchTitle: 'AI图片工具工作台',
    workbenchSubtitle: '探索强大的AI图片处理工具，让您的创意无限延伸',
    tryNow: '立即体验',
    moreComing: '更多工具即将推出',
    moreComingDescription: '我们正在不断开发新的AI图片处理工具，敬请期待！',
    imageToImage: '图像转图像',
    imageToImageDesc: '使用AI驱动的编辑和增强功能转换现有图像。',
    imageToImageDescription: '上传参考图像并使用AI驱动的编辑进行转换。非常适合风格转换、增强和创意修改。',
    textToImage: '文字转图像',
    textToImageDesc: '使用先进的AI从文字描述生成令人惊叹的图像。',
    textToImageDescription: '使用先进的AI技术从文字描述生成高质量图像。只需描述您想看到的内容，我们的AI将为您创建令人惊叹的视觉效果。',
    textToImageMode: '文字转图像模式',
    size: '尺寸',
    sizeDescriptions: {
      squareLarge: '正方形 (1:1)',
      portrait23: '竖版 (2:3)',
      landscape32: '横版 (3:2)',
      portrait34: '竖版 (3:4)',
      landscape43: '横版 (4:3)',
      portrait45: '竖版 (4:5)',
      landscape54: '横版 (5:4)',
      portrait916: '竖版 (9:16)',
      landscape169: '横版 (16:9)',
      ultrawide219: '超宽屏 (21:9)'
    }
  };
